import { render, staticRenderFns } from "./OH-SL-Disclosure.vue?vue&type=template&id=0f9391d7&scoped=true&"
import script from "./OH-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./OH-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./OH-SL-Disclosure.vue?vue&type=style&index=0&id=0f9391d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9391d7",
  null
  
)

export default component.exports